import { MessageKey } from '../i18n/messages';
import { TodoTaskStage } from '../web-api-client';

/**
 * Nhãn và màu cho vòng đời task (New/InProcess/End) — tách biệt khỏi kết quả hoàn thành ở
 * utils/taskStatus.ts. Tái dùng đúng ba màu tag đã có (idle/warn/ok) thay vì bịa thêm bảng màu mới.
 */
export const STAGE_LABEL_KEY: Record<TodoTaskStage, MessageKey> = {
  [TodoTaskStage.New]: 'taskStage.new',
  [TodoTaskStage.InProcess]: 'taskStage.inProcess',
  [TodoTaskStage.End]: 'taskStage.end'
};

export const STAGE_TAG_CLASS: Record<TodoTaskStage, string> = {
  [TodoTaskStage.New]: 'tag tag-idle',
  [TodoTaskStage.InProcess]: 'tag tag-warn',
  [TodoTaskStage.End]: 'tag tag-ok'
};

/**
 * Bấm được khi: đang New (để Start), hoặc đang InProcess và đã có kết quả (để Finish). Đang End thì
 * vòng đời đã kết thúc — chỉ còn đường quay lại là Restart, không phải bấm tiếp ở đây.
 */
export function canAdvanceStage(stage: TodoTaskStage, result: string | undefined): boolean {
  if (stage === TodoTaskStage.New) return true;
  if (stage === TodoTaskStage.InProcess) return !!result;
  return false;
}

/** Bắt đầu lại chỉ có ý nghĩa khi đã từng bắt đầu — New thì chưa có gì để làm lại. */
export function canRestartStage(stage: TodoTaskStage): boolean {
  return stage === TodoTaskStage.InProcess || stage === TodoTaskStage.End;
}
